import React from "react";

import "./profitData.css";
import { formatRupiah } from "../../../helper/formatNumber";

const ProfitData = ({ period, transactionData, onOpenDetailTransaction }) => {
  return (
    <div className="profit-table-container">
      <h4>Periode {period}</h4>
      <table className="profit-table">
        <thead>
          <tr>
            <th>No Invoice</th>
            <th>Staff</th>
            <th>Total Transaksi</th>
            <th>Profit</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {transactionData.length > 0 ? (
            transactionData.map((transaction, index) => (
              <tr key={index}>
                <td>{transaction.product_transaction_invoice_number}</td>
                <td>{transaction.staff_name}</td>
                <td>{formatRupiah(transaction.total_transaction)}</td>
                <td>{formatRupiah(transaction.perinvoice_profit)}</td>
                <td>
                  <button
                    className="profit-detail-button"
                    onClick={() => {
                      onOpenDetailTransaction(transaction);
                    }}
                  >
                    Lihat Detail
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ProfitData;
